import { render } from "./JadwalRombel.vue?vue&type=template&id=1e60dc0c"
import script from "./JadwalRombel.vue?vue&type=script&lang=js"
export * from "./JadwalRombel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__